export const getToasts = (state) => state.toasts.list;
export const getAutoDeleteTime = (state) => state.toasts.autoDeleteTime;
